import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  /**
   * Gets offers associated with a customer.
   * @param {String} customerIds - The identifier for a customer.
   * @returns {Promise<{offers: [{offerId: Number}]}>} A collection of offer objects.
   */
  async getOffers () {
    Logger.info('Started to get offers.')
    return tmxApiCall('get', '/offers')
  }
}
